import React from "react";
import { useState } from "react";
import axios from 'axios'
import {useDispatch,useSelector} from 'react-redux'
import gif from './loading.gif'
import { Link } from "react-router-dom";


function Speakers (props){
    const data = useSelector(state => state.speaker)
    const dispatch = useDispatch()
    const [load,setLoad] = useState(false)
    
    
    function getData (){
        axios.get(`/?id=WIrbis&action=Conference/GetAuthors&sid=${props.sid}`).then((resp) => {
          dispatch ({type:'TABLE_LOAD_SPEAKERS',payload5: resp.data})
       
          setLoad(true)
         
      })
      }
      
     
     let a = null
 

    if (load === false){
        
        return(
        <div className='loading'><img onLoad={getData()} src={gif} width='100' height='100'/> </div>   
        )
    }
    return(
            
            <div className="char-group">
                <div className="char">
                {
                    data.map((char) =>{
                        
                        if (char.family[0]!==a){
                            a = char.family[0]
                            return(
                                <>
                                <div className="char-1" key={char.iofull}>
                                <h1>{char.family[0]}</h1>
                                <ul>
                                    {
                                        data.map((member) => {
                                            if (member.family[0] == a){
                                                return(
                                                    <li ><Link to='/speaker' onClick={(e) => dispatch({type:'TABLE_LOAD_SPEAKER', payload6: member.id})}>{member.family + ' ' + member.io}</Link></li>)
                                                
                                            }
                                        })  
                                    }
                                </ul>
                                </div>
                                </>
                            )}
                         



                    
                    })
                  
                    
                  
                    
                }
               </div>
              
                
        </div>
      
     
                
        
        
       






    )








}

export default Speakers